"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosPromotionUpdateInputSchema = exports.APosPromotionCreateInputSchema = exports.APosPromotionSchema = exports.APosPromotionScheduleSchema = exports.APosPromotionRulesSchema = exports.APosPromotionStatusSchema = exports.APosPromotionTypeSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosPromotionTypeSchema = zod_1.z.enum([
    'percentage_discount', 'fixed_discount', 'bogo',
    'quantity_pricing', 'bundle', 'tiered_discount', 'free_item',
]);
exports.APosPromotionStatusSchema = zod_1.z.enum([
    'draft', 'scheduled', 'active', 'paused', 'expired',
]);
exports.APosPromotionRulesSchema = zod_1.z.object({
    discountPercent: zod_1.z.number().min(0).max(100).optional(),
    discountAmount: zod_1.z.number().nonnegative().optional(),
    maxDiscount: zod_1.z.number().nonnegative().optional(),
    minimumPurchase: zod_1.z.number().nonnegative().optional(),
    buyQuantity: zod_1.z.number().int().positive().optional(),
    getQuantity: zod_1.z.number().int().positive().optional(),
    getDiscountPercent: zod_1.z.number().min(0).max(100).optional(),
    quantity: zod_1.z.number().int().positive().optional(),
    price: zod_1.z.number().nonnegative().optional(),
    bundleItems: zod_1.z.array(zod_1.z.object({
        variantId: id_schema_1.EntityIdSchema,
        quantity: zod_1.z.number().int().positive(),
    })).optional(),
    bundlePrice: zod_1.z.number().nonnegative().optional(),
    tiers: zod_1.z.array(zod_1.z.object({
        minSpend: zod_1.z.number().nonnegative(),
        discountPercent: zod_1.z.number().min(0).max(100),
    })).optional(),
});
exports.APosPromotionScheduleSchema = zod_1.z.object({
    startDate: zod_1.z.number().optional(),
    endDate: zod_1.z.number().optional(),
    daysOfWeek: zod_1.z.array(zod_1.z.number().int().min(0).max(6)).optional(),
    startTime: zod_1.z.string().regex(/^\d{2}:\d{2}$/).optional(),
    endTime: zod_1.z.string().regex(/^\d{2}:\d{2}$/).optional(),
});
exports.APosPromotionSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    promotionId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(150),
    description: zod_1.z.string().max(500).optional(),
    type: exports.APosPromotionTypeSchema,
    rules: exports.APosPromotionRulesSchema,
    appliesTo: zod_1.z.object({
        scope: zod_1.z.enum(['all', 'category', 'brand', 'product', 'variant']),
        categoryIds: zod_1.z.array(zod_1.z.string()).optional(),
        brandIds: zod_1.z.array(zod_1.z.string()).optional(),
        productIds: zod_1.z.array(zod_1.z.string()).optional(),
        variantIds: zod_1.z.array(zod_1.z.string()).optional(),
    }),
    restrictions: zod_1.z.object({
        locationIds: zod_1.z.array(zod_1.z.string()).optional(),
        channels: zod_1.z.array(zod_1.z.string()).optional(),
        customerTiers: zod_1.z.array(zod_1.z.string()).optional(),
        newCustomersOnly: zod_1.z.boolean().optional(),
        excludeOnSaleItems: zod_1.z.boolean().optional(),
    }).optional(),
    schedule: exports.APosPromotionScheduleSchema.optional(),
    stacking: zod_1.z.object({
        allowStacking: zod_1.z.boolean().default(false),
        priority: zod_1.z.number().int().nonnegative().default(0),
        excludeWithCoupons: zod_1.z.boolean().optional(),
    }).optional(),
    limits: zod_1.z.object({
        maxUsesTotal: zod_1.z.number().int().positive().optional(),
        maxUsesPerCustomer: zod_1.z.number().int().positive().optional(),
    }).optional(),
    usageCount: zod_1.z.number().int().nonnegative().default(0),
    totalDiscountGiven: zod_1.z.number().nonnegative().default(0),
    status: exports.APosPromotionStatusSchema.default('draft'),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosPromotionCreateInputSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(150),
    description: zod_1.z.string().max(500).optional(),
    type: exports.APosPromotionTypeSchema,
    rules: exports.APosPromotionRulesSchema,
    appliesTo: exports.APosPromotionSchema.shape.appliesTo,
    restrictions: exports.APosPromotionSchema.shape.restrictions,
    schedule: exports.APosPromotionScheduleSchema.optional(),
    stacking: exports.APosPromotionSchema.shape.stacking,
    limits: exports.APosPromotionSchema.shape.limits,
});
exports.APosPromotionUpdateInputSchema = exports.APosPromotionCreateInputSchema.partial().extend({
    status: exports.APosPromotionStatusSchema.optional(),
});
//# sourceMappingURL=promotion.schema.js.map